import React from "react";
import { have_product_reference } from "../../../../../helpers/OrdersFunctionsGlobal";
import { url_to_store_by_reference } from "../../../../../helpers/Utils";
import { AiOutlineCheckCircle } from "react-icons/ai";

export default function OrderRowReference({ order_row = {}, order_shop = {} }) {
  return (
    <span>
      {have_product_reference(order_row.product_reference) ? (
        <span className="mr-1">
          {!!order_shop?.sms_tag ? (
            <a
              className={`text-primary `}
              href={order_row?.product_url != '#' && order_row?.product_url ? order_row?.product_url : url_to_store_by_reference(
                order_shop.sms_tag,
                order_row?.sku ? order_row.sku : order_row.product_reference
              )}
              target="_blank"
            >
              <span
                style={
                  order_row?.sku
                    ? {
                        color: "#FF0000",
                        textDecoration: "line-through",
                        marginRight: 5,
                      }
                    : { whiteSpace: "nowrap" }
                }
              >
                {order_row.product_reference}
              </span>
              {order_row?.sku && <>{order_row.sku}</>}
            </a>
          ) : (
            `[${order_row.product_reference}]`
          )}
        </span>
      ) : (
        <AiOutlineCheckCircle
          style={{ minWidth: 53 }}
          className={`text-${order_row.parent_id ? "success" : "danger"} mr-1`}
        />
      )}
      <span className="pl-2">{order_row.product_name || "Delivery"}</span>
    </span>
  );
}
